import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  access_token: null,
  refresh_token: null,
  roles: null,
  profile: {},
}

const authSlice = createSlice({
  name: 'auth',
  initialState: initialState,
  reducers: {
    setProfile(state, action) {
      state.profile = action.payload.profile
    },
    setRoles(state, action) {
      state.roles = action.payload.roles
    },
    login(state, action) {
      state.access_token = action.payload.access_token
      state.refresh_token = action.payload.refresh_token
    },
    setEmailAddress(state, action) {
      state.profile.email = action.payload.email
      state.profile.updated_at = action.payload.updated_at
    },
    logout(state) {
      Object.assign(state, initialState)
      window.location.href = '/login'
    }
  }
})

export const authActions = authSlice.actions

export const authReducer = authSlice.reducer
